import { Http } from '../../../../../../helpers/axois';
import { Option, DialogGroup } from './types';

export const api = {
	async createDialog(appId: string, payload: any) {
		try {
			const path = baseURL(appId);
			const res = await Http.post(path, payload).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async editDialog(appId: string, dialogId: string, payload: any) {
		try {
			const path = baseURL(appId) + `/${dialogId}`;
			const res = await Http.put(path, payload).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async getDialogs(appId: string, branchId: string) {
		try {
			const path = baseURL(appId) + `?branchId=${branchId}`;
			let dialogs: any = await Http.get(path).toPromise();
			return dialogs.map((dialog: any) => {
				const dialogGroups = dialog.dialogGroups.map((dialog: any) => {
					const dialogRes = dialog.response || {};
					delete dialog.response;
					if (dialog.responseType !== 'service') {
						return { ...dialog, ...dialogRes };
					} else {
						let actions: any = {};
						Object.entries(dialogRes).forEach(([key, value]: any) => {
							actions[key] = { type: value.type, ...value.response };
						});
						return { ...dialog, actions };
					}
				});
				dialogGroups.sort((a: any, b: any) => a.order - b.order);
				return {
					...dialog,
					dialogGroups,
				};
			}) as DialogGroup[];
		} catch (err) {
			throw err;
		}
	},

	async deleteDialog(appId: string, branchId: string, dialogId: string) {
		try {
			const path = baseURL(appId) + `/${dialogId}?branchId=${branchId}`;
			let res: any = await Http.delete(path).toPromise();
			return res;
		} catch (err) {
			throw err;
		}
	},

	async getFlows(appId: string, versionId: string) {
		try {
			const path = `/apps/${appId}/solo-flows?versionId=${versionId}`;
			const res: any = await Http.get(path).toPromise();
			return res.flows.map((flow: any) => ({
				id: flow.id,
				label: flow.name,
				value: flow.name,
			})) as Option[];
		} catch (err) {
			throw err;
		}
	},

	async getNodes(appId: string, versionId: string, flowId: string) {
		try {
			const path = `/apps/${appId}/solo-flows/${flowId}?versionId=${versionId}`;
			const res: any = await Http.get(path).toPromise();
			const startNode = res.source?.startNode ?? ""
			const nodes = res.source?.nodes?.filter((node: any) => { return node.type != "subflow" }).map((node: any) => ({
				value: node.id,
				label: node.name,
			}))  ?? []
			return {
				nodes,
				startNode
			} as { startNode: string, nodes: Option[] }
		} catch (err) {
			throw err;
		}
	},

	async getServices(appId: string, versionId: string) {
		try {
			const path = `/apps/${appId}/solo-services?versionId=${versionId}`;
			const res: any = await Http.get(path).toPromise();
			return res.services.map((service: any) => ({
				label: service.name,
				value: service.serviceKey,
			})) as Option[];
		} catch (err) {
			throw err;
		}
	},
};

function baseURL(appId: string) {
	return `/apps/${appId}/chat-qna/dialogs`;
}
